import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Snotify from 'vue-snotify';
import 'vue-snotify/styles/material.css'
import 'chart.piecelabel.js';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { max } from 'moment';
import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import ToggleButton from 'vue-js-toggle-button'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import fishList from '../data/fishList.js';
import { colors, months, monthNumbers, multiSelectOptions, colorPalete, ranges, maxDate, minDate } from '../data/constants.js'

Vue.use(Datetime);
Vue.use(ToggleButton);
Vue.use(Loading);
Vue.use(Snotify);
Vue.use(VueLodash, { name: 'custom', lodash: lodash })

Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker);

Vue.component('multiselect', Multiselect);

Vue.filter('toKilo', function (value) {
    return Math.round(value / 1000).toString();
});

Vue.filter('toMega', function (value) {
    return Math.round(value / 1000000).toString();
});

Vue.filter('toMegaDecimal', function (value) {
    return parseFloat(value / 1000000).toFixed(1).toString();
});

Vue.filter('toGiga', function (value) {
    return parseFloat(value / 1000000000).toFixed(1).toString();
});

Vue.filter('toTons', function (value) {
    if (value < 1000) {
        return (value / 1000).toFixed(3).toString();
    }
    else if (value < 10000) {
        return (value / 1000).toFixed(1).toString();
    }
    return Math.round(value / 1000).toString();
});

Vue.filter('separator', function (value) {
    try {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    } catch (e) {
        return value;
    }
});

Vue.filter('round', function (value) {
    if (value) {
        return Math.round(value).toString();
    }
    return value;
});

Vue.filter('shorten', function (value) {
    if (value) {
        return value.split('/')[0];
    }
    return value;
});

Vue.filter('formatPercentage', function (value) {
    if (Math.abs(value) >= 1000) {
        return '';
    }
    if (value > 0) {
        return '+' + value + '%';
    }
    return value + '%';
});

Vue.filter('formatPrice', function (value) {
    if (value > 0) {
        return value.toFixed(2).toString();
    }
    else if (value === 0) {
        return 'fri pris';
    }
    else if (value === -1) {
        return '';
    }
    return 'ukjent';
});

Vue.filter('formatSize', function (value) {
    if (value) {

        if (/^[-][0-9]{1,}.{0,}$/.test(value)) {
            return 'Under ' + value.substring(1).toLowerCase();
        }

        if (/^.{1,}[+].{0,}$/.test(value)) {
            return 'Over ' + value.replace("+", "").toLowerCase();
        }

        if (/^.{1,}[-].{1,}$/.test(value)) {
            return value.toLowerCase();
        }
    }
    return value;
});

Vue.filter('columnName', function (value) {
    switch (value) {
        case 'Week':
            return 'Uke';
        case 'Month':
            return 'Måned';
        case 'Year':
            return 'År';
        case 'Fish':
            return 'Art';
        case 'Condition':
            return 'Tilstand';
        case 'Conservation':
            return 'Konservering';
        case 'Zone':
            return 'Sone';
        case 'Gear':
            return 'Redskapsgruppe';
        case 'Size':
            return 'Vektklasse';
        case 'Quality':
            return 'Kvalitet';
        case 'Price':
            return 'Pris';
        case 'Quantity':
            return 'Rundvekt (tonn)';
        default:
            return value;
    }
});

Vue.filter('monthName', function (value) {
    if (parseInt(value)) {
        return months[parseInt(value) - 1];
    }
    return value;
});


Vue.filter('formatYear', function (value) {
    if (moment().year() === value) {
        return 'Hittil i år';
    }
    return value;
});

Vue.filter('convertToDateString', function (value) {
    if (value.length === 8) {
        const year = value.substring(0, 4);
        const month = value.substring(4, 6);
        const day = value.substring(6, 8);
        return day + "." + month + "." + year;
    }
    return value;
});

var app = new Vue({
    el: '#statisticDetails',
    components: {
        PulseLoader,
        Multiselect
    },

    data: {
        dateRange: null,

        fishOptions: fishList,
        selectedFish: null,
        fishOptionsLoading: false,

        conditionOptions: [],
        selectedCondition: null,
        fishConditionsLoading: false,

        conservationOptions: [],
        selectedDropdownConservation: null,
        conservationOptionsLoading: false,

        weightOptions: [],
        selectedWeight: null,
        weightOptionsLoading: false,

        qualityOptions: [],
        selectedQuality: null,
        qualityOptionsLoading: false,

        showForeignVessels: false,

        weekGrouping: false,

        postpaid: false,

        areaOptions: [],
        selectedArea: null,
        areaOptionsLoading: false,

        gearOptions: [],
        selectedGear: null,
        gearOptionsLoading: false,

        quotaOptions: [],
        selectedQuota: null,
        quotaOptionsLoading: false,

        productTypeOptions: [{ Key: 'H', Name: 'Hovedprodukt' }, { Key: 'B', Name: 'Biprodukt' }, { Key: '', Name: 'Alle' }],
        selectedProductType: { Key: 'H', Name: 'Hovedprodukt' },

        queryResults: [],

        isLoading: false,
        afterFirstRun: false,
        queryParams: null,

        selectedYearData: null,
        selectedFishId: null,
        selectedFishConservations: null,
        selectedConservation: null,

        isMobileScreen: window.innerWidth < 576 ? true : false,

    },

    watch: {
        dateRange: function (val) {
            // this.selectedFish = null
            // this.fishOptions = []
            // this.resetDropdowns(4)
            if (this.isRangeValid) {
                if (this.dateRange.end > moment().format("YYYYMMDD")) {
                    this.dateRange.end = moment().format("YYYYMMDD");
                }
                // this.getFishTypes(val);
            }
        },

        selectedFish: function (val) {
            this.resetDropdowns(4);
        },

        selectedProductType: function (val) {
            this.selectedFish = null
            // this.fishOptions = []
            this.resetDropdowns(4)
            if (val) {
                // this.getFishTypes(val);
            }
        },

        selectedCondition: function (val) {
            this.resetDropdowns(3);
        },

        selectedDropdownConservation: function (val) {
            this.resetDropdowns(2);
        },

        selectedWeight: function (val) {
            if (val) {
                this.getFishQualities();
            }
        },

        queryResults: function(val) {
            var output = this._.groupBy(val, function (person) {
                var props = ['Condition', 'Size', 'Quality'],
                    prop = [];

                for (var i = 0, length = props.length; i < length; i++) {
                    prop.push(person[props[i]]);
                }

                return prop.join('|');
            });

            var array = Object.keys(output)
                .map(function (key) {
                    return output[key];
                });
        },

        selectedFishId: function (val) {
            var self = this;
            if (val) {
                self.selectedConservation = Object.keys(self.selectedFishConservations)[0];
                self.refreshFishData();
            }
            else {
                self.refreshPieChartData(self.selectedYearData.Year);
            }
        },
    },

    computed: {
        columnNames: function () {
            if (this.queryResults.length > 0) {
                return Object.keys(this.queryResults[0])
            }
            return []
        },

        selectedFishCode: function () {
            if (this.selectedFish !== null) {
                return this.selectedFish.Code;
            }
            return null;
        },

        rekeFilteredConservations: function () {
            if (this.selectedFishCode === 2524) {
                return this.conservationOptions.filter(function (obj) {
                    return obj.Code !== 5;
                });
            }
            return this.conservationOptions;
        },

        isRangeValid: function() {
            if (this.dateRange && this.dateRange.start && this.dateRange.end) {
                return true;
            }
            return false;
        },

        isInvalid: function() {
            if (this.selectedFish && (!this.selectedCondition || this.selectedCondition.length === 0) && (!this.selectedDropdownConservation || !this.selectedDropdownConservation === 0)) {
                return true;
            }
        },

        groupedQueryResults: function () {
            var output = this._.groupBy(this.queryResults, function (person) {
                var props = ['Condition', 'Conservation', 'Zone', 'Gear'],
                    prop = [];

                for (var i = 0, length = props.length; i < length; i++) {
                    prop.push(person[props[i]]);
                }

                return prop.join('|');
            });

            var array = Object.keys(output)
                .map(function (key) {
                    return output[key];
                });

            return array;
        },
    },

    methods: {
        // not in use
        getFishTypes: function (year) {
            var self = this;
            self.fishOptionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetFishTypes/', {
                params: {
                    startDate: self.dateRange && self.dateRange.start,
                    endDate: self.dateRange && self.dateRange.end,
                }
            })
                .then((response) => {
                    self.fishOptionsLoading = false;
                    if (response.data !== 'error') {
                        self.fishOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.fishOptionsLoading = false;
                    console.log(error);
                });
        },

        getFishConditions: function () {
            var self = this;
            self.selectedCondition = null;
            self.conditionOptions = [];
            self.fishConditionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetFishConditions/', {
                params: {
                    startDate: self.dateRange && self.dateRange.start,
                    endDate: self.dateRange && self.dateRange.end,
                    fishId: self.selectedFish && self.selectedFish.Key,
                    conditionId: null,
                    conservationId: self.selectedDropdownConservation && self.selectedDropdownConservation.map(q => q.Key).join(),
                    weightId: self.selectedWeight && self.selectedWeight.Key,
                    foreignVessels: self.showForeignVessels,
                    productTypeId: self.selectedProductType.Key
                }
            })
                .then((response) => {
                    self.fishConditionsLoading = false;
                    if (response.data !== 'error') {
                        self.conditionOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.fishConditionsLoading = false;
                    console.log(error);
                });
        },

        getFishConservations: function () {
            var self = this;
            self.selectedDropdownConservation = null;
            self.conservationOptions = [];
            self.conservationOptionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetFishConservations/', {
                params: {
                    startDate: self.dateRange && self.dateRange.start,
                    endDate: self.dateRange && self.dateRange.end,
                    fishId: self.selectedFish && self.selectedFish.Key,
                    conditionId: self.selectedCondition && self.selectedCondition.map(q => q.Key).join(),
                    conservationId: null,
                    weightId: self.selectedWeight && self.selectedWeight.Key,
                    foreignVessels: self.showForeignVessels,
                    productTypeId: self.selectedProductType.Key
                }
            })
                .then((response) => {
                    self.conservationOptionsLoading = false;
                    if (response.data !== 'error') {
                        self.conservationOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.conservationOptionsLoading = false;
                    console.log(error);
                });
        },

        loadFishConditions: function () {
            var self = this;
            if (self.conditionOptions.length === 0) {
                self.getFishConditions();
            }
        },

        loadFishConservations: function () {
            var self = this;
            if (self.conservationOptions.length === 0) {
                self.getFishConservations();
            }
        },

        loadWeights: function () {
            var self = this;
            if (self.weightOptions.length === 0) {
                self.getFishWeights();
            }
        },

        loadQualities: function () {
            var self = this;
            if (self.qualityOptions.length === 0) {
                self.getFishQualities();
            }
        },

        loadAreas: function () {
            var self = this;
            if (self.areaOptions.length === 0) {
                self.getAreas();
            }
        },

        loadGears: function () {
            var self = this;
            if (self.gearOptions.length === 0) {
                self.getGears();
            }
        },

        getFishWeights: function () {
            var self = this;
            self.selectedWeight = null;
            self.weightOptions = [];
            self.weightOptionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetFishWeights/', {
                params: {
                    startDate: self.dateRange && self.dateRange.start,
                    endDate: self.dateRange && self.dateRange.end,
                    fishId: self.selectedFish && self.selectedFish.Key,
                    conditionId: self.selectedCondition && self.selectedCondition.map(q => q.Key).join(),
                    conservationId: self.selectedDropdownConservation && self.selectedDropdownConservation.map(q => q.Key).join(),
                    weightId: null,
                    foreignVessels: self.showForeignVessels,
                    productTypeId: self.selectedProductType.Key
                }
            })
                .then((response) => {
                    self.weightOptionsLoading = false;
                    if (response.data !== 'error') {
                        self.weightOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.weightOptionsLoading = false;
                    console.log(error);
                });
        },

        getFishQualities: function () {
            var self = this;
            self.selectedQuality = null;
            self.qualityOptions = [];
            self.qualityOptionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetFishQualities/', {
                params: {
                    startDate: self.dateRange && self.dateRange.start,
                    endDate: self.dateRange && self.dateRange.end,
                    fishId: self.selectedFish && self.selectedFish.Key,
                    conditionId: self.selectedCondition && self.selectedCondition.map(q => q.Key).join(),
                    conservationId: self.selectedDropdownConservation && self.selectedDropdownConservation.map(q => q.Key).join(),
                    weightId: self.selectedWeight && self.selectedWeight.Key,
                    foreignVessels: self.showForeignVessels,
                    productTypeId: self.selectedProductType.Key
                }
            })
                .then((response) => {
                    self.qualityOptionsLoading = false;
                    if (response.data !== 'error') {
                        self.qualityOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.qualityOptionsLoading = false;
                    console.log(error);
                });
        },

        getAreas: function () {
            var self = this;
            self.selectedArea = null;
            self.areaOptions = [];
            self.areaOptionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetAreas/')
                .then((response) => {
                    self.areaOptionsLoading = false;
                    if (response.data !== 'error') {
                        self.areaOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.areaOptionsLoading = false;
                    console.log(error);
                });
        },

        getGears: function () {
            var self = this;
            self.selectedGear = null;
            self.gearOptions = [];
            self.gearOptionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetGears/', {
                params: {
                    startDate: self.dateRange && self.dateRange.start,
                    endDate: self.dateRange && self.dateRange.end,
                    fishId: self.selectedFish && self.selectedFish.Key,
                    conditionId: self.selectedCondition && self.selectedCondition.map(q => q.Key).join(),
                    conservationId: self.selectedDropdownConservation && self.selectedDropdownConservation.map(q => q.Key).join(),
                }
            })
                .then((response) => {
                    self.gearOptionsLoading = false;
                    if (response.data !== 'error') {
                        self.gearOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.gearOptionsLoadingss = false;
                    console.log(error);
                });
        },

        loadQuotas: function () {
            var self = this;
            if (self.quotaOptions.length === 0) {
                self.getQuotas();
            }
        },

        getQuotas: function () {
            var self = this;
            self.selectedQuota = null;
            self.quotaOptions = [];
            self.quotaOptionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetQuotaTypes/', {
                params: {
                    startDate: self.dateRange && self.dateRange.start,
                    endDate: self.dateRange && self.dateRange.end,
                    fishId: self.selectedFish && self.selectedFish.Key,
                    conditionId: self.selectedCondition && self.selectedCondition.Key,
                    conservationId: self.selectedDropdownConservation && self.selectedDropdownConservation.Key,
                    weightId: self.selectedWeight && self.selectedWeight.Key,
                }
            })
                .then((response) => {
                    self.quotaOptionsLoading = false;
                    if (response.data !== 'error') {
                        self.quotaOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.quotaOptionsLoading = false;
                    console.log(error);
                });
        },

        resetDropdowns: function (number) {
            var self = this;
            if (number > 4) {
                self.dateRange = null;
                self.afterFirstRun = false;
                self.queryResults = [];
            }

            if (number > 3) {
                self.selectedCondition = null
                self.conditionOptions = []
            }
            if (number > 2) {
                self.selectedDropdownConservation = null
                self.conservationOptions = []
            }

            self.selectedWeight = null
            self.selectedQuality = null
            self.selectedGear = null
            self.selectedArea = null
            self.selectedQuota = null
            self.weightOptions = []
            self.qualityOptions = []
            self.gearOptions = []
            self.quotaOptions = []
        },

        getQueryResults: function () {
            var self = this;
            self.queryResults = [];
            self.isLoading = true;
            self.queryParams= {
                startDate: self.dateRange && self.dateRange.start,
                endDate: self.dateRange && self.dateRange.end,
                selectedFish: self.selectedFish && self.selectedFish.Name,
                selectedCondition: self.selectedCondition && self.selectedCondition.map(q => q.Name).join(),
                selectedDropdownConservation: self.selectedDropdownConservation && self.selectedDropdownConservation.map(q => q.Name).join(),
                selectedWeight: self.selectedWeight && self.selectedWeight.Name,
                selectedQuality: self.selectedQuality && self.selectedQuality.Name,
                showForeignVessels: self.showForeignVessels,
                selectedArea: self.selectedArea && self.selectedArea.map(q => q.Name).join(),
                selectedGear: self.selectedGear && self.selectedGear.map(q => q.Name).join(),
                selectedProductType: self.selectedProductType.Name,
                selectedQuotaType: self.selectedQuota && self.selectedQuota.Name,
                dateGrouping: self.weekGrouping ? 'Week' : 'Month',
                postpaid: self.postpaid
            }

            axios.get('/umbraco/Surface/Statistic/GetQueryResults/', {
                params: {
                    startDate: self.dateRange && self.dateRange.start,
                    endDate: self.dateRange && self.dateRange.end,
                    fishId: self.selectedFish && self.selectedFish.Key,
                    conditionId: self.selectedCondition && self.selectedCondition.map(q => q.Key).join(),
                    conservationId: self.selectedDropdownConservation && self.selectedDropdownConservation.map(q => q.Key).join(),
                    weightId: self.selectedWeight && self.selectedWeight.Key,
                    qualityId: self.selectedQuality && self.selectedQuality.Key,
                    foreignVessels: self.showForeignVessels,
                    areaId: self.selectedArea && self.selectedArea.map(q => q.Key).join(),
                    gearId: self.selectedGear && self.selectedGear.map(q => q.Key).join(),
                    productTypeId: self.selectedProductType.Key,
                    quotaType:  self.selectedQuota && self.selectedQuota.Key,
                    dateGrouping: self.weekGrouping ? 'Week' : 'Month',
                    postpaid: self.postpaid
                }
            })
                .then((response) => {
                    if (response.data !== 'error') {
                        self.queryResults = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                    self.isLoading = false;
                    self.afterFirstRun = true;
                })
                .catch(function (error) {
                    self.isLoading = false;
                    console.log(error);
                });
        },

        getPlaceholder: function (element) {
            if (element === 'fish') {
                if (!this.fishOptionsLoading) {
                    return 'Velg art'
                } 
            }
            else if (element === 'condition') {
                if (!this.fishConditionsLoading) {
                    if (Array.isArray(this.selectedDropdownConservation) && this.selectedDropdownConservation.length > 0) {
                        return 'Alle tilstander'
                    }
                    return 'Velg tilstand/er'
                }
            }
            else if (element === 'conservation') {
                if (!this.conservationOptionsLoading) {
                    if (Array.isArray(this.selectedCondition) && this.selectedCondition.length > 0) {
                        return 'Alle konserveringer'
                    }
                    return 'Velg konservering/er'
                }
            }
            else if (element === 'weight') {
                if (!this.weightOptionsLoading) {
                    return 'Alle vektklasser'
                }
            }
            else if (element === 'quality') {
                if (!this.qualityOptionsLoading) {
                    return 'Alle kvaliteter'
                }
            }
            else if (element === 'area') {
                if (!this.areaOptionsLoading) {
                    return 'Alle soner'
                }
            }
            else if (element === 'gear') {
                if (!this.gearOptionsLoading) {
                    return 'Alle redskap'
                }
            }
            else if (element === 'quotas') {
                if (!this.gearOptionsLoading) {
                    return 'Alle kvote'
                }
            }
            return 'Laster inn'
        },

        mapOrder(array, order, key) {
            array.sort(function (a, b) {
                var A = a[key], B = b[key];

                if (order.indexOf(A) > order.indexOf(B)) {
                    return 1;
                } else {
                    return -1;
                }
            });
            return array;
        },

        formatWeight({ Key, Name }) {
            if (Name) {

                if (/^[-][0-9]{1,}.{0,}$/.test(Name)) {
                    return 'Under ' + Name.substring(1).toLowerCase();
                }

                if (/^.{1,}[+].{0,}$/.test(Name)) {
                    return 'Over ' + Name.replace("+", "").toLowerCase();
                }

                if (/^.{1,}[-].{1,}$/.test(Name)) {
                    return Name.toLowerCase();
                }
            }
            return Name;
        },

        shorten({ Name }) {
            return Name.split('/')[0];
        },

        priceAvg: function (array) {
            if (array) {
                return array.reduce((n, { Price, Quantity }) => n + Price * Quantity, 0) / this.quantitySum(array);
            }
            return 0;
        },

        quantitySum: function (array) {
            if (array) {
                return array.reduce((n, { Quantity }) => n + Quantity, 0)
            }
            return 0;
        },

        displayErrorNotification(error) {
            this.$snotify.error(error, {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        },

        showDataLoader(container) {
            var self = this;
            var loader = self.$loading.show({
                container: self.$refs[container],
                loader: 'spinner',
                color: '#007bff',
                isFullPage: false
            });
            return loader;
        },

        update(data) {
            //console.log(data);
        },

        closeDropdown(multiselectElement) {
            var self = this;
            self.$refs[multiselectElement].deactivate(); 
        },
    },

    created() {
        var self = this
        document.addEventListener("setYear", function (e) {
            //console.log(e.detail);
            self.selectYearData(e.detail)
        });

        self.multiSelectOptions = multiSelectOptions;
        self.months = months;
        self.ranges = ranges;
        self.maxDate = maxDate;
        self.minDate = minDate;
    },

    mounted() {

    }
});


// WEBPACK FOOTER //
// ./Scripts/app/statisticDetails/index.js